import React, { useEffect, useLayoutEffect, useState } from "react";
import EZSProtectionPlan from "./ezs/EZSProtectionPlan";
import IDFProtectionPlan from "./idf/IDFProtectionPlan";
import BusinessProtectionPlan from "./business/BusinessProtectionPlan";
import * as services from "../../../store/service";
import { ApplicationState } from "../../../store";
import { useDispatch, useSelector } from "react-redux";
import * as ProtectionPlanActions from "../../../store/protectionPlanService/business/actions";
import * as ConfigurationActions from "../../../store/configurationService/actions";
import TUAuthentication from "../../Credit/Auth/TUAuthentication";

const ProtectionPlan = (props: any) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [isIdfUser, setIsIdfUser] = useState(false);
    const [isSmbLicenseUser, setIsSmbLicenseUser] = useState(false);
    const requestProtectionPlan = (forcefullyRefresh: boolean) => dispatch(ProtectionPlanActions.actionCreators.requestProtectionPlan(forcefullyRefresh));
    const protectionPlanSelector = useSelector((state: ApplicationState) => {
        return state.protectionPlanBusinessState;
    });
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));

    useLayoutEffect(() => {
        const initialUrl = window.location.origin + "/app/manage-account/my-account";
        sessionStorage.setItem("initialUrl", encodeURIComponent(initialUrl));
        setLoading(true);

        services.isIdfUser().then((data: any) => {
            setLoading(false);
            data == true ? setIsIdfUser(true) : setIsIdfUser(false);

            if (data === false) {
                requestProtectionPlan(true);
            }
        });
    }, []);

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    useEffect(() => {
        if (protectionPlanSelector && !protectionPlanSelector.isLoading && protectionPlanSelector.protectionPlanData?.smbLicenseLimits?.length) {
            setIsSmbLicenseUser(true);
        }
    }, [protectionPlanSelector]);

    return (
        <React.Fragment>
            <TUAuthentication />

            {loading ? (
                <div className="box loading"></div>
            ) : (
                <React.Fragment>
                    {isSmbLicenseUser ? (
                        <BusinessProtectionPlan />
                    ) : (
                        <React.Fragment>{isIdfUser ? <IDFProtectionPlan history={props.history} /> : <EZSProtectionPlan />}</React.Fragment>
                    )}
                </React.Fragment>
            )}
        </React.Fragment>
    );
};

export default ProtectionPlan;
